import React, { useState, useEffect, useRef } from "react";
import api from "../../Api";
import chevrondownup from "../../image/subway_down-.png";
import CustomToastContainer from "../Common/CustomToastContainer";
import Select2 from "../Common/Select2Wrapper";
import "select2/dist/js/select2.min.js";
import { usePopup } from "../Common/PopupContext";
import Login from "../Website/Login";
import {
  jobSectors,
  jobCategories,
  salaryRanges,
  jobSkills,
  radiusOptions,
  experienceLevels,
  jobTypes,
  Remote,
  jobIndustryTools,
  qualifications,
  jobcertifications,
} from "../../helpers/Object";
import axios from "axios";
import { submitform } from "../../helpers/Formhelper";
const BASE_URL_PLATFORM = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const clientdomain = process.env.REACT_APP_DOMAIN;
const chevrondown = clientdomain + "/subway_down-2.png";
const JobSearchForm = ({ onSubmit = () => {}, industry, resetForm }) => {
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedJobType, setSelectedJobType] = useState("");
  const [Title, setTitle] = useState("");
  const [selectedSalaryRange, setSelectedSalaryRange] = useState("");
  const [selectedRadius, setSelectedRadius] = useState("");
  const [selectedExperienceLevel, setSelectedExperienceLevel] = useState("");
  const [selectedRemote, setSelectedRemote] = useState("");
  const [selectedQualification, setSelectedQualification] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [Tools, setTools] = useState([]);
  const [render, setrender] = useState(0);
  const [certifications, setCertification] = useState([]);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTools, setSelectedTools] = useState([]);
  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const toastRef = useRef();
  const [selectedSkills, setSelectedSkills] = useState([]);
  const toggleSection = () => {
    setIsVisible(!isVisible);
    if (isVisible == false) {
      var increseHeight = document.getElementsByClassName(
        "CareerOpportunities"
      );

      // if (increseHeight) {
      //   increseHeight[0].style.height = "100vh";
      // }
    } else {
      var increseHeight = document.getElementsByClassName(
        "CareerOpportunities"
      );
      if (increseHeight) {
        // increseHeight[0].style.height = "192px";
      }
    }
  };

  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [isHiringVisible, setIsHiringVisible] = useState(false);

  useEffect(() => {
    setSelectedIndustry(industry);
    if (window.google) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ["geocode"],
          componentRestrictions: { country: "uk" },
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        setInputValue(place.formatted_address);
      });

      return () => {
        window.google.maps.event.clearInstanceListeners(autocomplete);
      };
    }
    setTimeout(() => {
      setIsHiringVisible(true);
    }, 1500);
  }, [render]);
  const buttonRef = useRef(null);
  const { openPopup } = usePopup();
  // Function to handle key down event
  const handleKeyDown = (e) => {
    // Check if the pressed key is 'Enter'
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission if within a form
      buttonRef.current.click(); // Trigger button click
    }
  };
  const findJob = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formdata = {
      selectedIndustry,
      selectedJobType,
      selectedSalaryRange,
      selectedRadius,
      selectedExperienceLevel,
      selectedRemote,
      selectedQualification,
      selectedCategory,
      selectedTools,
      selectedCertifications,
      selectedSkills,
      selectedCategories,
      location: inputValue,
      title: Title,
    };
    try {
      const response = await api.searchJob(formdata);
      console.log(response);

      if (response?.jobsData?.length > 0) {
        // Iterate over each job in the response data
        const formattedJobs = response?.jobsData.map((job) => {
          // Check if job has a pay object and format its values
          if (job.pay) {
            if (job.pay.minimum !== undefined) {
              job.pay.minimum = parseFloat(job.pay.minimum).toFixed(2);
            }
            if (job.pay.maximum !== undefined) {
              job.pay.maximum = parseFloat(job.pay.maximum).toFixed(2);
            }
            if (job.pay.rate !== undefined && job.pay.rate !== null) {
              job.pay.rate = parseFloat(job.pay.rate).toFixed(2);
            }
          }
          return job;
        });

        // Pass the formatted jobs to onSubmit
        onSubmit(formattedJobs, response.totalRecords, response?.totalPages);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error posting job:", error);
    }
  };
  const handleClosePopup = (message) => {
    //console.log(message);
    openPopup();
  };

  const handleClickEmployee = () => {
    const popup = (
      <Login
        onClose={() => handleClosePopup("Popup closed")}
        employee="employee"
      />
    );
    openPopup(popup);
  };
  const handleClear = (e) => {
    e.preventDefault();
    setLoading(true);

    // Reset the form by its ID
    document.getElementById("jobsearchform").reset();

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Check if 'industry' parameter exists and is not valid
    if (!industry || industry != "" || industry != undefined) {
      // Remove the 'industry' parameter
      params.delete("industry");
    }

    // Update the URL without refreshing the page (fixed template literal usage)
    window.history.replaceState({}, "", `${url.pathname}${params.toString()}`);
    window.location.reload();
    // No need to reassign 'industry' as a constant
    setrender(render + 1);
    setLoading(false);
  };

  const handleIndustryChange = (e) => {
    const industry = e.target.value;
    setSelectedIndustry(industry);
    setSelectedCategory("");
    if (industry) {
      const filteredCategories = jobCategories[industry].filter(Boolean); // Remove undefined or null categories
      setCategories(filteredCategories);
      // setSelectedCategories(jobCategories[industry]);
      setSkills(jobSkills[industry] || []);
      setCertification(jobcertifications[industry] || []);
      setTools(jobIndustryTools[industry]);
    } else {
      // setCategories([]);
      // setSkills([]);
      // setTools([]);
    }
  };
  const handleCategoriesChange = (e) => {
    setSelectedCategories(
      Array.from(e.target.selectedOptions, (option) => option.value)
    );
  };

  const handleSkillsChange = (e) => {
    setSelectedSkills(
      Array.from(e.target.selectedOptions, (option) => option.value)
    );
  };

  const handleCertificationsChange = (e) => {
    setSelectedCertifications(
      Array.from(e.target.selectedOptions, (option) => option.value)
    );
  };

  const handleToolsChange = (e) => {
    setSelectedTools(
      Array.from(e.target.selectedOptions, (option) => option.value)
    );
  };
  return (
    <section className="jobs-form-section">
      <form id="jobsearchform">
        <div className="form-open-line-outer">
          {/* <JobSearch /> */}
          <div className="form-open-line-outer-inner  ">
            <div
              className={
                isVisible
                  ? "FIND-JOB-search-active  mt-10 flex "
                  : "FIND-JOB-search  md:flex"
              }
            >
              <div
                className="lg:flex md:flex sm:block  PopularJobCategories lg:gap-3
"
              >
                <div className="FIND-JOB-input">
                  <div>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.146 15.3707 4.888 14.112C3.63 12.8533 3.00067 11.316 3 9.5C2.99933 7.684 3.62867 6.14667 4.888 4.888C6.14733 3.62933 7.68467 3 9.5 3C11.3153 3 12.853 3.62933 14.113 4.888C15.373 6.14667 16.002 7.684 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8127 13.5627 12.688 12.688C13.5633 11.8133 14.0007 10.7507 14 9.5C13.9993 8.24933 13.562 7.187 12.688 6.313C11.814 5.439 10.7513 5.00133 9.5 5C8.24867 4.99867 7.18633 5.43633 6.313 6.313C5.43967 7.18967 5.002 8.252 5 9.5C4.998 10.748 5.43567 11.8107 6.313 12.688C7.19033 13.5653 8.25267 14.0027 9.5 14Z"
                        fill="#003366"
                      />
                    </svg>
                  </div>
                  <div className="search">
                    <input
                      type="search"
                      name="title"
                      onKeyDown={handleKeyDown}
                      value={Title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="What ?"
                      className="p-1 mr-2 w-full no-border text-base/6"
                    />
                  </div>
                </div>
                <div className="FIND-JOB-Category">
                  <div>
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_28_1125)">
                        <path
                          d="M18.2234 12.8532L11.9601 11.8227L12.8586 11.1829L14.3628 11.3911L15.865 11.1829L18.2234 12.8532ZM14.3628 1.01706C14.6613 1.01706 14.957 1.07589 15.2329 1.19018C15.5087 1.30446 15.7593 1.47198 15.9704 1.68315C16.1816 1.89432 16.349 2.14501 16.4632 2.4209C16.5774 2.69679 16.6361 2.99247 16.636 3.29106C16.636 4.54731 15.8354 5.56506 14.3628 5.56506C14.0607 5.57055 13.7605 5.51579 13.4798 5.40397C13.1991 5.29215 12.9435 5.12553 12.7279 4.91382C12.5123 4.70212 12.3411 4.44958 12.2242 4.17096C12.1073 3.89234 12.0471 3.59321 12.0471 3.29106C12.0471 2.98891 12.1073 2.68979 12.2242 2.41117C12.3411 2.13254 12.5123 1.88 12.7279 1.6683C12.9435 1.4566 13.1991 1.28997 13.4798 1.17816C13.7605 1.06634 14.0607 1.01158 14.3628 1.01706ZM14.9286 17.4518V22.9474C14.9286 23.2767 15.0594 23.5926 15.2923 23.8254C15.5251 24.0583 15.841 24.1891 16.1703 24.1891C16.4996 24.1891 16.8154 24.0583 17.0482 23.8254C17.2811 23.5926 17.4119 23.2767 17.4119 22.9474V17.4518C17.4039 17.1278 17.2696 16.8197 17.0376 16.5934C16.8056 16.367 16.4944 16.2403 16.1703 16.2403C15.8461 16.2403 15.5349 16.367 15.3029 16.5934C15.0709 16.8197 14.9366 17.1278 14.9286 17.4518ZM22.5344 20.5894C22.5343 20.7804 22.4585 20.9635 22.3236 21.0986C22.1887 21.2337 22.0057 21.3098 21.8148 21.3102H18.0078V17.7117H19.6544V14.1154C19.6544 13.7194 19.9773 13.3962 20.3736 13.3962H21.8148C22.2108 13.3962 22.5344 13.7191 22.5344 14.1154V20.5894ZM14.3346 21.3098H6.94375C6.84914 21.3098 6.75545 21.2912 6.66805 21.2549C6.58065 21.2187 6.50124 21.1656 6.43437 21.0987C6.3675 21.0317 6.31448 20.9523 6.27835 20.8648C6.24221 20.7774 6.22366 20.6837 6.22375 20.5891V14.1151C6.22395 13.9242 6.2999 13.7413 6.4349 13.6064C6.56991 13.4716 6.75293 13.3958 6.94375 13.3958H8.38413C8.78125 13.3958 9.10413 13.7187 9.10413 14.1151V17.7113H14.3346V21.3098ZM10.4429 13.5454C10.3895 13.8703 10.4672 14.2032 10.659 14.4708C10.8508 14.7384 11.141 14.9189 11.4659 14.9727L16.888 15.8663C17.2129 15.9194 17.5456 15.8414 17.813 15.6495C18.0804 15.4575 18.2608 15.1673 18.3145 14.8426C18.3411 14.6817 18.3357 14.5172 18.2987 14.3585C18.2617 14.1998 18.1937 14.0499 18.0987 13.9174C18.0037 13.785 17.8835 13.6725 17.745 13.5866C17.6065 13.5006 17.4524 13.4428 17.2915 13.4164L11.8694 12.5221C11.5446 12.469 11.2119 12.5469 10.9445 12.7388C10.6771 12.9306 10.4967 13.2207 10.4429 13.5454ZM4.32775 6.73919C2.5585 6.73919 1.11963 5.30031 1.11963 3.52994C1.11963 1.75956 2.5585 0.320312 4.32775 0.320312C6.097 0.320312 7.53775 1.75994 7.53775 3.52994C7.53775 5.30031 6.097 6.73919 4.32775 6.73919ZM4.32775 5.94494C4.96814 5.94414 5.58208 5.68942 6.03494 5.23664C6.4878 4.78385 6.74261 4.16995 6.7435 3.52956C6.7435 2.19869 5.65863 1.11419 4.32775 1.11419C2.99575 1.11419 1.9135 2.19869 1.9135 3.52956C1.9139 4.16984 2.16835 4.7838 2.62099 5.23666C3.07363 5.68951 3.68747 5.94424 4.32775 5.94494Z"
                          fill="#003366"
                        />
                        <path
                          d="M4.34444 3.95368C4.30768 3.97057 4.26724 3.97785 4.2269 3.97483C4.18656 3.97181 4.14765 3.9586 4.11382 3.93643C4.085 3.91797 4.06046 3.89356 4.04183 3.86485C4.02321 3.83614 4.01093 3.80378 4.00582 3.76993L4.00244 1.90468C4.0049 1.84233 4.0314 1.78335 4.07639 1.7401C4.12137 1.69685 4.18135 1.6727 4.24375 1.6727C4.30616 1.6727 4.36614 1.69685 4.41112 1.7401C4.45611 1.78335 4.48261 1.84233 4.48507 1.90468V3.35181L5.72219 2.76906C5.75079 2.75541 5.78181 2.74753 5.81346 2.74589C5.84511 2.74426 5.87677 2.74888 5.90663 2.75951C5.93649 2.77013 5.96396 2.78655 5.98745 2.80782C6.01095 2.82908 6.03002 2.85478 6.04357 2.88343C6.07078 2.94134 6.07395 3.00766 6.05237 3.0679C6.0308 3.12813 5.98623 3.17736 5.92844 3.20481L4.34444 3.95331V3.95368ZM14.3629 7.37406L17.3108 6.89406V8.96631L18.7662 10.0609C18.9061 10.2019 18.8494 10.3624 18.8164 10.4078C18.7769 10.4604 18.7181 10.4953 18.653 10.5047C18.5879 10.5141 18.5216 10.4973 18.4688 10.4581L16.6321 9.06981C16.4491 8.94614 16.2249 8.89912 16.0077 8.93886C15.7905 8.97861 15.5975 9.10193 15.4702 9.28237C15.3428 9.4628 15.2913 9.68597 15.3267 9.90396C15.3621 10.1219 15.4815 10.3174 15.6593 10.4483L18.7977 12.6526C18.9436 12.7553 19.1509 12.8254 19.3576 12.8254C19.5338 12.8254 19.7412 12.7523 19.8957 12.6428C20.2249 12.4088 20.3461 11.9937 20.2343 11.6112L19.0688 8.16718C18.7576 7.31143 17.9727 6.30418 16.7937 6.30418H11.9318C10.7532 6.30418 9.96832 7.31143 9.65669 8.16718L8.49119 11.6112C8.37907 11.9937 8.50094 12.4092 8.83019 12.6428C8.98357 12.7523 9.19169 12.8254 9.36719 12.8254C9.57494 12.8254 9.78269 12.7557 9.92819 12.6526L13.0666 10.4483C13.2444 10.3174 13.3638 10.1219 13.3992 9.90396C13.4346 9.68597 13.383 9.4628 13.2557 9.28237C13.1284 9.10193 12.9354 8.97861 12.7182 8.93886C12.5009 8.89912 12.2768 8.94614 12.0938 9.06981L10.2559 10.4581C10.2032 10.4972 10.1371 10.5139 10.0721 10.5045C10.0072 10.495 9.94853 10.4603 9.90907 10.4078C9.87574 10.3532 9.86246 10.2888 9.87149 10.2255C9.88053 10.1622 9.91131 10.104 9.95857 10.0609C9.95857 10.0609 10.9456 9.31956 11.4147 8.96631V6.89406L14.3629 7.37443V7.37406Z"
                          fill="#003366"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_28_1125">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.320312)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="relative w-full">
                    <Select2
                      className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                      id="jobSector"
                      name="industry"
                      multiple={false}
                      onChange={(e) => handleIndustryChange(e)}
                      defaultValue={selectedIndustry}
                      data={jobSectors.map((sector, index) => ({
                        id: sector.value,
                        text: sector.label,
                      }))}
                      options={{
                        placeholder: "Type Job Sectors",
                      }}
                    />
                  </div>
                </div>
                <div className="FIND-JOB-Location">
                  <div>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 13.5C11.2583 13.5 10.5333 13.2801 9.91661 12.868C9.29993 12.456 8.81928 11.8703 8.53545 11.1851C8.25162 10.4998 8.17736 9.74584 8.32206 9.01841C8.46675 8.29098 8.8239 7.6228 9.34835 7.09835C9.8728 6.5739 10.541 6.21675 11.2684 6.07206C11.9958 5.92736 12.7498 6.00162 13.4351 6.28545C14.1203 6.56928 14.706 7.04993 15.118 7.66661C15.5301 8.2833 15.75 9.00832 15.75 9.75C15.7488 10.7442 15.3533 11.6973 14.6503 12.4003C13.9473 13.1033 12.9942 13.4988 12 13.5ZM12 7.5C11.555 7.5 11.12 7.63196 10.75 7.8792C10.38 8.12643 10.0916 8.47783 9.92127 8.88896C9.75098 9.3001 9.70642 9.7525 9.79323 10.189C9.88005 10.6254 10.0943 11.0263 10.409 11.341C10.7237 11.6557 11.1246 11.87 11.561 11.9568C11.9975 12.0436 12.4499 11.999 12.861 11.8287C13.2722 11.6584 13.6236 11.37 13.8708 11C14.118 10.63 14.25 10.195 14.25 9.75C14.2494 9.15345 14.0122 8.5815 13.5903 8.15967C13.1685 7.73784 12.5966 7.5006 12 7.5Z"
                        fill="#003366"
                      />
                      <path
                        d="M12 22.5L5.67301 15.0382C5.58509 14.9262 5.49809 14.8135 5.41201 14.7C4.33179 13.276 3.74799 11.5373 3.75001 9.75C3.75001 7.56196 4.6192 5.46354 6.16637 3.91637C7.71355 2.36919 9.81197 1.5 12 1.5C14.188 1.5 16.2865 2.36919 17.8336 3.91637C19.3808 5.46354 20.25 7.56196 20.25 9.75C20.2517 11.5365 19.6682 13.2743 18.5888 14.6978L18.588 14.7C18.588 14.7 18.363 14.9955 18.3293 15.0353L12 22.5ZM6.60975 13.7963C6.60975 13.7963 6.7845 14.0272 6.82425 14.0767L12 20.181L17.1825 14.0685C17.2155 14.0272 17.391 13.7948 17.3918 13.794C18.2747 12.6309 18.7518 11.2103 18.75 9.75C18.75 7.95979 18.0388 6.2429 16.773 4.97703C15.5071 3.71116 13.7902 3 12 3C10.2098 3 8.4929 3.71116 7.22703 4.97703C5.96116 6.2429 5.25001 7.95979 5.25001 9.75C5.24815 11.2112 5.72584 12.6327 6.60975 13.7963Z"
                        fill="#003366"
                      />
                    </svg>
                  </div>

                  <div className="Location-search">
                    <input
                      ref={inputRef}
                      type="text"
                      onKeyDown={handleKeyDown}
                      name="location"
                      className="no-border p-1 mr-2 w-full no-border appearance-none text-base/8"
                      placeholder="Where"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              {!isVisible && (
                <div className="hrp-find-btn">
                  <button
                    type="button"
                    ref={buttonRef}
                    className="text-white FIND-JOB-btn"
                    onClick={(e) => findJob(e)}
                  >
                    Find Job
                  </button>
                </div>
              )}
            </div>
          </div>
          {!isVisible && (
            <div>
              <div className="form-open-line" id="btn-1">
                <div className="form-open-line-inner" onClick={toggleSection}>
                  <img
                    src={chevrondown}
                    alt="icon"
                    loading="lazy"
                    width="100%"
                    height="200px"
                  />
                </div>
              </div>
            </div>
          )}
          {isVisible && (
            <div
              className="mx-auto pt-8 pb-8 px-4 shadow-md"
              id="hiddenSection"
            >
              <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5">
                <div className="relative mt-1 job-search-label-section singleselect2">
                  <Select2
                    id="jobType"
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="jobType"
                    value={selectedJobType}
                    multiple={false}
                    data={jobTypes?.map((type) => ({
                      id: type.value,
                      text: type.label,
                    }))}
                    options={{
                      placeholder: "Select Job Type",
                      theme: "classic",
                      width: "resolve",
                    }}
                    onSelect={(e) =>
                      setSelectedJobType(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                  />
                  <label
                    htmlFor="jobType"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Job Type
                  </label>
                </div>
                <div className="relative job-search-label-section singleselect2">
                  <Select2
                    id="pay"
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="showPayBy"
                    multiple={false}
                    value={selectedSalaryRange}
                    data={salaryRanges?.map((salaryRange) => ({
                      id: salaryRange.value,
                      text: salaryRange.label,
                    }))}
                    onSelect={(e) =>
                      setSelectedSalaryRange(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                    options={{
                      placeholder: "Select Salary Range",
                      theme: "classic",
                      width: "resolve",
                    }}
                  />
                  <label
                    htmlFor="pay"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Salary Range
                  </label>
                </div>
                <div className="relative job-search-label-section singleselect2">
                  <Select2
                    id="radius"
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="radius"
                    multiple={false}
                    value={selectedRadius}
                    data={radiusOptions?.map((type) => ({
                      id: type.value,
                      text: type.label,
                    }))}
                    onSelect={(e) =>
                      setSelectedRadius(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                    options={{
                      placeholder: "Select Radius",
                      theme: "classic",
                      width: "resolve",
                    }}
                  />
                  <label
                    htmlFor="radius"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Radius
                  </label>
                </div>
                <div className="relative job-search-label-section singleselect2">
                  <Select2
                    id="experienceLevel"
                    value={selectedExperienceLevel}
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="experienceLevel"
                    multiple={false}
                    onSelect={(e) =>
                      setSelectedExperienceLevel(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                    data={experienceLevels?.map((experienceLevel) => ({
                      id: experienceLevel.value,
                      text: experienceLevel.label,
                    }))}
                    options={{
                      placeholder: "Select Experience",
                      theme: "classic",
                      width: "resolve",
                    }}
                  />
                  <label
                    htmlFor="experienceLevel"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Experience
                  </label>
                </div>
                <div className="relative job-search-label-section singleselect2">
                  <Select2
                    id="remote"
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="remote"
                    multiple={false}
                    value={selectedRemote}
                    onSelect={(e) =>
                      setSelectedRemote(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                    data={Remote?.map((Remotes) => ({
                      id: Remotes.value,
                      text: Remotes.label,
                    }))}
                    options={{
                      placeholder: "Select Remote",
                      theme: "classic",
                      width: "resolve",
                    }}
                  />
                  <label
                    htmlFor="remote"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Remote
                  </label>
                </div>
                <div className="relative job-search-label-section singleselect2">
                  <Select2
                    id="educationLevel"
                    className="jobsearchsector p-1 mr-2 w-full no-border appearance-none text-base/8"
                    name="educationLevel"
                    value={selectedQualification}
                    multiple={false}
                    onSelect={(e) =>
                      setSelectedQualification(
                        Array.from(
                          e.target.selectedOptions,
                          (option) => option.value
                        )
                      )
                    }
                    data={qualifications}
                    options={{
                      placeholder: "Select Qualifications",
                      theme: "classic",
                      width: "resolve",
                    }}
                  />
                  <label
                    htmlFor="educationLevel"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Qualification
                  </label>
                </div>
              </div>
              <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-5">
                {/* Categories */}
                <div className="text-justify">
                  <div className="mt-1 flex flex-wrap job-search-label-section">
                    <Select2
                      className="categoriesdropdown"
                      id="categories"
                      name="categories"
                      multiple
                      value={selectedCategories} // Controlled input with state
                      onSelect={(e) =>
                        setSelectedCategories(
                          Array.from(
                            e.target.selectedOptions,
                            (option) => option.value
                          )
                        )
                      } // Update state on change
                      data={categories}
                      options={{
                        placeholder: "Type Categories",
                      }}
                    />
                    <label
                      htmlFor="categories"
                      className="block text-sm font-medium py-1 text-gray-700 multipleselectlabelskill"
                    >
                      Categories
                    </label>
                  </div>
                </div>

                {/* Skills */}
                <div className="text-justify">
                  <div className="mt-1 flex flex-wrap job-search-label-section">
                    <Select2
                      id="skills"
                      name="skills"
                      multiple
                      value={selectedSkills} // Controlled input with state
                      onSelect={handleSkillsChange} // Update state on change
                      data={skills}
                      options={{
                        placeholder: "Type Skills",
                      }}
                    />
                    <label
                      htmlFor="skills"
                      className="block text-gray-700 font-medium multipleselectlabelskill"
                    >
                      Skills
                    </label>
                  </div>
                </div>

                {/* Certifications */}
                <div className="job-search-label-section">
                  <Select2
                    id="certification"
                    name="certification"
                    multiple
                    value={selectedCertifications} // Controlled input with state
                    onSelect={handleCertificationsChange} // Update state on change
                    data={certifications}
                    options={{
                      placeholder: "Type Certifications",
                    }}
                  />
                  <label
                    htmlFor="certification"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Certification
                  </label>
                </div>

                {/* Tools */}
                <div className="job-search-label-section">
                  <Select2
                    id="tools"
                    name="tools"
                    multiple
                    value={selectedTools} // Controlled input with state
                    onSelect={handleToolsChange} // Update state on change
                    data={Tools}
                    options={{
                      placeholder: "Type Tools",
                    }}
                  />
                  <label
                    htmlFor="tools"
                    className="block text-sm font-medium text-gray-700 multipleselectlabelskill"
                  >
                    Tools Known
                  </label>
                </div>
              </div>
              <div className="mt-5 text-align-end flex justify-end">
                <button
                  type="button"
                  className="joblist-cardbtnapply"
                  onClick={(e) => handleClear(e)}
                >
                  Clear
                </button>
                <button
                  type="button"
                  ref={buttonRef}
                  // name="submitbtn"
                  className="md:w-auto md:px-10 px-7 py-3 text-xl text-white shadow-sm"
                  onClick={(e) => findJob(e)}
                >
                  Find Job
                </button>
              </div>
            </div>
          )}
          {isVisible && (
            <div className="form-open-line-bottom" id="btn-2">
              <div
                className="form-open-line-inner-bottom"
                onClick={toggleSection}
              >
                <img src={chevrondownup} alt="closeicon" loading="lazy" />
              </div>
            </div>
          )}
        </div>

        {loading && (
          <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
            <span className="RoadmapSpinner"></span>
          </div>
        )}
      </form>
      <CustomToastContainer ref={toastRef} />
    </section>
  );
};

export default JobSearchForm;
